import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseSection from '../BaseSection';

const InfrastructureSection = memo(infrastructures => {
  const { t } = useTranslation();

  return (
    <BaseSection>
      <div className="infrastructure-container">
        <div className="infrastructure">
          <div className="infrastructure__title">
            {t('residences.infrastructure')}
          </div>
          <div className="infrastructure-i">
            {infrastructures &&
              infrastructures?.infrastructures.map((item, index) => (
                <div className="infrastructure-i__item" key={index}>
                  <img src={item.infrastructure.iconUrl} alt="" />
                  <div className="infrastructure-i__item__title">
                    {item.infrastructure.name}
                  </div>
                  <div className="infrastructure-i__item__description">
                    {t('residences.minutes', { minutes: item.distance })}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </BaseSection>
  );
});

InfrastructureSection.displayName = `InfrastructureSection`;

InfrastructureSection.propTypes = {
  priceMin: PropTypes.number,
  priceMax: PropTypes.number,
  currency: PropTypes.string,
  deadline: PropTypes.string
};

export default InfrastructureSection;
